import { FC, KeyboardEvent, MouseEvent } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useMediaQuery } from 'react-responsive';
import { Button } from 'src/components';
import { SwipeHint } from '../SwipeHint';

const msgs = defineMessages({
  continue: { id: 'learn_presentation_card_continue' },
});

type ContinueControlProps = {
  /** Full-screen video overlay: swipe on touch, Continue when a mouse is available */
  overlay?: boolean;
  onClick: (event?: MouseEvent) => void;
  onKeyUp: (event: KeyboardEvent) => void;
  disabled?: boolean;
};

/**
 * On the mobile video overlay, touch-first devices get a swipe hint; narrow
 * desktop / tablet-with-mouse get a Continue button (swipe and wheel still work).
 */
export const ContinueControl: FC<ContinueControlProps> = ({
  overlay = false,
  onClick,
  onKeyUp,
  disabled = false,
}) => {
  const intl = useIntl();
  const hasFinePointer = useMediaQuery({ query: '(any-pointer: fine)' });

  if (overlay && !hasFinePointer) {
    return <SwipeHint onClick={onClick} onKeyUp={onKeyUp} />;
  }

  return (
    <Button
      buttonType="primary"
      buttonSize="medium"
      onClick={onClick}
      onKeyUp={onKeyUp}
      disabled={disabled}
      data-testid="blob-continue"
    >
      {intl.formatMessage(msgs.continue)}
    </Button>
  );
};
